import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { XIcon } from 'lucide-react';
interface PrivacyPopupProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}
export const PrivacyPopup: React.FC<PrivacyPopupProps> = ({
  open,
  onOpenChange
}) => {
  return <Dialog.Root open={open} onOpenChange={onOpenChange} data-id="element-187">
      <Dialog.Portal data-id="element-188">
        <Dialog.Overlay className="fixed inset-0 bg-black/50 z-40" data-id="element-189" />
        <Dialog.Content className="fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg p-6 max-w-md w-full max-h-[85vh] overflow-y-auto z-50" data-id="element-190">
          <div className="flex justify-between items-start mb-4" data-id="element-191">
            <Dialog.Title className="text-xl font-medium text-[#444]" data-id="element-192">
              Política de Privacidad
            </Dialog.Title>
            <Dialog.Close asChild data-id="element-193">
              <button className="text-[#8e7f7a] hover:text-[#444]" data-id="element-194">
                <XIcon size={20} data-id="element-195" />
              </button>
            </Dialog.Close>
          </div>
          <div className="space-y-4 text-[#5a5553]" data-id="element-196">
            <h3 className="font-medium" data-id="element-197">1. Información que Recopilamos</h3>
            <p data-id="element-198">
              Recopilamos información personal como nombre, dirección de correo
              electrónico y datos de pago necesarios para procesar tu compra y
              entregarte los productos digitales.
            </p>
            <h3 className="font-medium" data-id="element-199">2. Uso de la Información</h3>
            <p data-id="element-200">
              Utilizamos tu información para procesar pedidos, proporcionar
              acceso a los materiales digitales, enviar actualizaciones sobre
              productos, y mejorar nuestros servicios.
            </p>
            <h3 className="font-medium" data-id="element-201">3. Protección de Datos</h3>
            <p data-id="element-202">
              Implementamos medidas de seguridad para proteger tu información
              personal contra acceso no autorizado, alteración, divulgación o
              destrucción.
            </p>
            <h3 className="font-medium" data-id="element-203">4. Cookies</h3>
            <p data-id="element-204">
              Utilizamos cookies para mejorar la experiencia del usuario,
              analizar el tráfico del sitio y personalizar el contenido. Puedes
              configurar tu navegador para rechazar cookies, pero esto puede
              afectar la funcionalidad del sitio.
            </p>
            <h3 className="font-medium" data-id="element-205">5. Compartir Información</h3>
            <p data-id="element-206">
              No vendemos ni alquilamos tu información personal a terceros.
              Podemos compartir información con proveedores de servicios que nos
              ayudan a operar nuestro negocio (procesadores de pago, servicios
              de email marketing).
            </p>
            <h3 className="font-medium" data-id="element-207">6. Derechos del Usuario</h3>
            <p data-id="element-208">
              Tienes derecho a acceder, corregir o eliminar tu información
              personal. Para ejercer estos derechos, contáctanos a través de
              nuestra sección de contacto.
            </p>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>;
};